export default "__VITE_ASSET__BYxFNR6k__"